(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vn-product-scroll"]) return;
  try {
    
  (function () {
    /* ---------- 1) Scroll por bloques en la ficha (escritorio) ---------- */
    if (!window.__vnBlockScroll) {
      window.__vnBlockScroll = true;

      var mq = window.matchMedia('(min-width: 750px)');
      var grid = null;
      var details = null;
      var list = null;
      var D = 0;
      var L2 = 0;
      var V = 0;
      var frame = 0;
      var observed = [];
      var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

      function find() {
        var g = document.querySelector('[id$="__main"] .product-information__grid');
        if (!g) return false;
        grid = g;
        details = g.querySelector('.product-details');
        list = g.querySelector('media-gallery .media-gallery__grid');
        return !!(details && list);
      }

      function reset() {
        if (grid) {
          grid.removeAttribute('data-vn-blocks');
          grid.style.removeProperty('--vn-shift');
        }
      }

      function measure() {
        if (!mq.matches || !find()) {
          reset();
          return;
        }

        /* medir con el estado natural (sin nuestro alto minimo) */
        grid.removeAttribute('data-vn-blocks');
        D = details.offsetHeight;
        var G = list.offsetHeight;
        V = window.innerHeight;
        L2 = Math.max(0, G - V);

        grid.style.setProperty('--vn-frame', V + 'px');
        grid.style.setProperty('--vn-grid-min', D + L2 + 'px');
        grid.style.setProperty('--vn-details-top', Math.min(0, V - D) + 'px');
        grid.setAttribute('data-vn-blocks', '');

        if (resizeObserver) {
          var targets = [details, list];
          for (var i = 0; i < targets.length; i++) {
            if (observed.indexOf(targets[i]) === -1) {
              observed.push(targets[i]);
              resizeObserver.observe(targets[i]);
            }
          }
        }
        update();
      }

      function update() {
        if (!grid || !grid.hasAttribute('data-vn-blocks')) return;
        var top = grid.getBoundingClientRect().top;
        var shift = Math.min(Math.max(V - (top + D), 0), L2);
        grid.style.setProperty('--vn-shift', String(Math.round(shift * 10) / 10));
      }

      function schedule() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(measure);
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', schedule);
      window.addEventListener('load', schedule);
      document.addEventListener('DOMContentLoaded', schedule);
      if (mq.addEventListener) mq.addEventListener('change', schedule);

      /* la galeria se sustituye entera al elegir otro color: volver a medir */
      new MutationObserver(function () {
        var currentList = document.querySelector('[id$="__main"] media-gallery .media-gallery__grid');
        if (currentList && currentList !== list) {
          observed = [];
          schedule();
        }
      }).observe(document.documentElement, { childList: true, subtree: true });

      schedule();
    }

    /* ---------- 2) Cambio de foto de portada al elegir un color (tarjetas) ---------- */
    if (!window.__vnCardSwatches) {
      window.__vnCardSwatches = true;

      var canHover = function () {
        return window.matchMedia('(hover: hover)').matches;
      };

      var coverOf = function (link) {
        var card = link.closest('product-card');
        return card ? card.querySelector('.card-gallery__layer--base img, .card-gallery img') : null;
      };

      var show = function (link) {
        var img = coverOf(link);
        if (!img || !link.dataset.vnSrc) return;
        if (!('vnOrigSrc' in img.dataset)) {
          img.dataset.vnOrigSrc = img.getAttribute('src') || '';
          img.dataset.vnOrigSrcset = img.getAttribute('srcset') || '';
          img.dataset.vnOrigSizes = img.getAttribute('sizes') || '';
        }
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = link.dataset.vnSrc;
      };

      var restore = function (box) {
        var link = box.querySelector('.vn-cs__link');
        var img = link && coverOf(link);
        if (!img || !('vnOrigSrc' in img.dataset)) return;
        if (img.dataset.vnOrigSrcset) img.setAttribute('srcset', img.dataset.vnOrigSrcset);
        if (img.dataset.vnOrigSizes) img.setAttribute('sizes', img.dataset.vnOrigSizes);
        img.src = img.dataset.vnOrigSrc;
        delete img.dataset.vnOrigSrc;
        delete img.dataset.vnOrigSrcset;
        delete img.dataset.vnOrigSizes;
      };

      document.addEventListener('mouseover', function (event) {
        if (!canHover()) return;
        var link = event.target.closest && event.target.closest('.vn-cs__link');
        if (link) show(link);
      });

      document.addEventListener('mouseout', function (event) {
        if (!canHover()) return;
        var box = event.target.closest && event.target.closest('.vn-cs');
        if (box && !(event.relatedTarget && box.contains(event.relatedTarget))) restore(box);
      });

      /* En movil: tocar un color cambia la portada y se queda asi (no abre la ficha) */
      document.addEventListener('click', function (event) {
        if (canHover()) return;
        var link = event.target.closest && event.target.closest('.vn-cs__link');
        if (!link) return;
        event.preventDefault();
        var box = link.closest('.vn-cs');
        var all = box.querySelectorAll('.vn-cs__link.is-active');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
        link.classList.add('is-active');
        show(link);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
